import { render, staticRenderFns } from "./AssociarProdutoFornecedor.vue?vue&type=template&id=6c19215c&scoped=true"
import script from "./AssociarProdutoFornecedor.vue?vue&type=script&lang=js"
export * from "./AssociarProdutoFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c19215c",
  null
  
)

export default component.exports